// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { ILevelGeneralDto } from 'src/app/infrastructure/models/level-general-dto';
import { IImageData, imageData } from 'src/app/features/image/models/image-data';
import { IImageBoxDto } from './image-box-dto.g';

export const imageDto = {
    guid: 'guid',
    fileName: 'fileName',
    extension: 'extension',
    fileVariantType_Name: 'fileVariantType_Name',
    description: 'description',
    contentType: 'contentType',
    folderShardPath: 'folderShardPath',
    height: 'height',
    width: 'width',
    modifiedOn: 'modifiedOn',
    inactive: 'inactive',
    deleted: 'deleted',
} as const;

export type TImageDto = (typeof imageDto)[keyof typeof imageDto];

export const imageDtoConstraints = {
} as const;

export type TImageDtoConstraints = typeof imageDtoConstraints;

export interface IImageDto extends ILevelGeneralDto {
    [imageDto.guid]: string | null;
    [imageDto.fileName]: string | null;
    [imageDto.extension]: string | null;
    [imageDto.fileVariantType_Name]: string | null;
    [imageDto.description]: string | null;
    [imageDto.contentType]: string | null;
    [imageDto.folderShardPath]: string | null;
    [imageDto.height]: number | null;
    [imageDto.width]: number | null;
    [imageDto.modifiedOn]: string | null;
    [imageDto.inactive]: boolean | null;
    [imageDto.deleted]: boolean | null;
}

export class ImageDto
    implements IImageDto
{
    [imageDto.guid]: string | null = null;
    [imageDto.fileName]: string | null = null;
    [imageDto.extension]: string | null = null;
    [imageDto.fileVariantType_Name]: string | null = null;
    [imageDto.description]: string | null = null;
    [imageDto.contentType]: string | null = null;
    [imageDto.folderShardPath]: string | null = null;
    [imageDto.height]: number | null = null;
    [imageDto.width]: number | null = null;
    [imageDto.modifiedOn]: string | null = null;
    [imageDto.inactive]: boolean | null = null;
    [imageDto.deleted]: boolean | null = null;

    private constructor();
    private constructor(modelData: IImageData);
    private constructor(value1?: IImageData) {
        if (value1) {
            const _modelData = value1 as IImageData;
            this[imageDto.description] = _modelData?.[imageData.description];
            this[imageDto.deleted] = _modelData?.[imageData.deleted];
        }
    }

    static create(modelForm?: IImageData | null): ImageDto | null {
        return modelForm ? new ImageDto(modelForm) : null;
    }
}
